var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "29px",
    viewBox: "0 0 20 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(-169.000000, -19.000000)",
    fill: "#DC0451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(169.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-location"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4303704,9.58756338 C14.4303704,7.25919014 12.4431746,5.3416162 9.98296296,5.3416162 C7.5226455,5.3416162 5.53555556,7.25919014 5.53555556,9.58756338 C5.53555556,11.9616831 7.5226455,13.8791549 9.98296296,13.8791549 C12.4431746,13.8791549 14.4303704,11.9616831 14.4303704,9.58756338 M19.9659259,9.63320775 C19.9659259,14.9748239 9.98296296,28.9453697 9.98296296,28.9453697 C9.98296296,28.9453697 0,14.9748239 0,9.63320775 C0,4.33723592 4.44740741,0 9.98296296,0 C15.5185185,0 19.9659259,4.33723592 19.9659259,9.63320775",
    id: "Fill-1"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.b6f8b21918833be80aca18ce750fb2ee.svg";
export { ForwardRef as ReactComponent };